module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAANCAYAAACZ3F9/AAABNklEQVQokYXQP2tUQRyF4WfjCjIXgoKIhaJoK4I2tiKIhaRMsYUWgt1cLNPYpNHGbgpTi9oIFilEEfYLSCCQILERsRO0UcY/oP4svAmDG/XAFMOZdw68o4jQpust4wrm8LwW1+2SUQt2vRVcwwK+4BGmtZgM/RkcqMV0B+x6R/EaJ2vxtvnsDS7hM+7hCBbHzfp+vG+hIe+wF5dxGvuwNLfd1mJjWLjfrN3EcWzVYgWreFGLSbsIF/Gk6z3FN5zDYi2+D/1tpBk5f0iax3ItXs08aMGudwJ3cBgf8BMHsQertbg1A3a9CR76rf8B1vEVh3AeS/hRi2M7ZMpxNuWIlONqRPjbSTk2U45n23cpx1rKcfdfUAN/TDkuRIQxTuFG15vHaDcRQz7hJTKmY2wNmv+XGGQ9hl9YJKJuZkzEEgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reg_3.png
// module id = ttec
// module chunks = 1